import React, { useContext } from 'react';
import { settingContext } from '../../../UseContext/SettingContext';
import { Link } from 'react-router-dom';
import { AwsFileUrl, BASEURL, } from '../../../../../config';



const SettingInputUser = ({ settingNav, settingKey, settingType, header, message, commentNote, repliesNote, tagNote }) => {

  const { 
    
    showLoadMore, inputValue, showList, list, selected, added,

    handleFocus,
    handleChange,
    handleLoadMore,
    handleBlur,
    handleSelect,
    handleRemove,
    handleCreate,

    handleDelete,

  } = useContext(settingContext);

  return (
    <>
      <section className={`${message && `mb-3`} px-0`}>
        {header && <h6 className='fw-medium mb-1'>{header}</h6>}

        {/* Selected users */}
        <div className='d-flex align-items-center'>
          <div className={`${selected[settingKey] && selected[settingKey].length !== 0 && `border shadow-sm`} px-0 py-1 rounded-1 me-2 w-100`}>
            <div className={`${selected[settingKey] && `m-1`}`}>
              {
                selected[settingKey] 
                && 
                selected[settingKey].map((user, index) => (
                  <div className='d-inline-block px-3 me-2 mb-2 rounded-1 text-white bg-primary shadow-sm' key={index}>
                    <Link to={`${BASEURL}/profile/${user._id}`} className='cursor-pointer text-white'>{user.userName}</Link>
                    <span className='cursor-pointer ms-3' onClick={() => handleRemove(settingKey, user)}>x</span>
                  </div>
                ))
              }
            </div>

            <input type="text" className='form-control form-control-sm d-inline' placeholder='Search...'
              onFocus={() => handleFocus(inputValue, list.length, settingNav, settingKey, settingType)} 
              onBlur={handleBlur}   
              onChange={(e) => handleChange(e, settingNav, settingKey, settingType)}
            />
          </div>

          <button type="button" className='btn btn-sm btn-primary ms-lg-2' onClick={() => handleCreate(settingNav, settingKey, settingType)} 
            disabled={(!selected[settingKey]) || (selected[settingKey].length === 0)}
          >Add</button>
        </div>

        {message && <small className='form-text'>({message})</small>}

        {commentNote && <small className='form-text'>Note : - You can further filter comments by selecting inappropriate words, phrases, emojis in <a href='#hideWords' className='text-primary cursor-pointer'>Hide Words</a>, to hide comments containing them.</small>}

        {repliesNote && <small className='form-text'>Note : - You can further filter replies by selecting inappropriate words, phrases, emojis in <a href='#hideWords' className='text-primary cursor-pointer'>Hide Words</a>, to hide replies containing them.</small>}

        {tagNote && <small className='form-text'>Note : - if you have tagged any person in your post it will be also visible to their audience, if they allow.</small>}

        {/* search user List */}
        <>
          {
            (settingKey === showList && list && list.length > 0)
            &&
            <div className='position-relative'>
              <div className='p-2 position-absolute bg-white overflow-y-scroll z-1 rounded-1 shadow' style={{ maxHeight: '267px' }}>
                {
                  list.map((user, index) => (
                    <div className='d-flex align-items-center mb-2 cursor-pointer' key={index} 
                      onMouseDown={(e) => e.preventDefault()} 
                      onClick={() => handleSelect(user)}
                    >
                      <img className='border rounded-circle' src={`${AwsFileUrl+user.profile}`} alt="profile" style={{ height: '40px', width: '40px' }} />

                      <div className='mx-3'>
                        <h6 className='fw-semibold mb-0'>{user.fullName}</h6>
                        <span>{user.userName}</span>
                      </div>
                    </div>
                  ))
                }

                {/* Load More */}
                {
                  showLoadMore
                  ?
                  <div className='text-center mt-3 mb-1'>
                    <button type="button" className='btn btn-primary btn-sm' 
                      onMouseDown={(e) => e.preventDefault()}
                      onClick={() => handleLoadMore(inputValue, list.length, settingNav, settingKey, settingType)}
                    >Load More</button>
                  </div>
                  :
                  <div className='text-center mt-3 mb-1 text-secondary'>No users...</div>
                }
              </div>
            </div>
          }
        </>

        {/* Added users */}
        <>
          {
            (added && added[settingKey] && added[settingKey].length > 0)
            &&
            <div className='mt-3 py-1'>
              {
                added[settingKey].map((user, index) => (
                  <div className='d-inline-block px-3 me-2 mb-2 rounded-1 text-white bg-primary shadow-sm' key={index}>
                    <Link to={`${BASEURL}/profile/${user._id}`} className='cursor-pointer text-white'>{user.userName}</Link>
                    <span className='cursor-pointer ms-3' onClick={() => handleDelete(settingNav, settingKey, settingType, user._id)}>x</span>
                  </div>
                ))
              }
            </div>
          }
        </>
      </section>
    </>
  )
}

export default SettingInputUser;